import { AxiosInstance } from 'axios';
import { createRequestId } from './requestId';

export function attachRequestContext(apiInstance: AxiosInstance): void {
  apiInstance.interceptors.request.use((config) => {
    config.headers = config.headers ?? {};
    config.headers['X-Request-Id'] = createRequestId();
    return config;
  });
}
